const AuthDivider = () => (
	<div className="relative my-6">
		<div className="absolute inset-0 flex items-center">
			<div className="w-full border-t border-border" />
		</div>
		<div className="relative flex justify-center text-xs">
			<span className="rounded-full bg-card px-3 text-muted-foreground">
				Prefer email and password?
			</span>
		</div>
	</div>
);
export default AuthDivider;